import { format } from 'date-fns'
import * as React from 'react'
import { KvBox } from 'src/design-system/components/atoms/kvbox'
import { ChartLine, UsersThree } from '@phosphor-icons/react'
import { HeadcountOverview } from './headcount-overview'
import { OrgSnapshot } from './types'
import { formatCurrency as $ } from './utils'
import styles from './WorkforceIntelligence.module.scss'

export const OrgSummary: React.VFC<
  Pick<
    OrgSnapshot,
    'orgSize' | 'totalCost' | 'numRoles' | 'avgSalary' | 'teams' | 'timestamp'
  >
> = ({ orgSize, totalCost, numRoles, avgSalary, teams, timestamp }) => (
  <div className={styles.orgSummary}>
    <div className={styles.headingContainer}>
      <h2 className={styles.sectionHeading}>
        <ChartLine
          color="#5e6580"
          height="24px"
          width="24px"
          style={{ marginRight: '0.5rem' }}
        />
        Org Summary
      </h2>
      <time dateTime={timestamp.toISOString()}>
        {format(timestamp, 'MMM d, yyyy h:mm a')}
      </time>
    </div>
    <KvBox Key="Organization Size" value={orgSize} />
    <KvBox Key="Total Cost" value={$(totalCost ?? 0)} />
    <KvBox Key="Roles" value={numRoles} />
    <KvBox Key="Avg Salary" value={$(avgSalary ?? 0)} />

    <h2 className={styles.sectionHeading}>
      <UsersThree
        color="#5e6580"
        height="24px"
        width="24px"
        style={{ marginRight: '0.5rem' }}
      />
      Team Headcount
    </h2>
    <HeadcountOverview teams={teams} />
  </div>
)
